import firebase from "firebase";
import FirebaseConfig from "@/components/FirebaseConfig";
const firebaseApp = firebase.initializeApp(FirebaseConfig);
export default firebaseApp.functions('europe-west1');